import withStyles from '@mui/styles/withStyles';

const GlobalCss = withStyles((theme) => ({
  // @global is handled by jss-plugin-global.
  '@global': {
    // You should target [class*="MuiButton-root"] instead if you nest themes.
    ':root': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
    body: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
    },
  },
}))(() => null);

export default GlobalCss;
